export const CUSTOMER_ROUTE_FREQUENCY_EXPORT_ID = "Reporte - Cliente y Frecuencia de Rutas";
export const CUSTOMER_ROUTE_FREQUENCY_TITLE = "Reporte - Cliente y Frecuencia de Rutas";

export const CUSTOMER_ROUTE_FREQUENCY_PROPERTIES = {
  routeName: "Territorio",
  subRouteName: "Ruta",
  responsibleName: "Responsable",
  type: "Tipo de ruta",
  function: "Función",
  custmerCode: "Código de cliente",
  custmerName: "Nombre de cliente",
  days: "Días",
};

export const CUSTOMER_TERRITORIES_EXPORT_ID = "Reporte - Clientes y Territorios";
export const CUSTOMER_TERRITORIES_TITLE = "Reporte - Clientes y Territorios";

export const CUSTOMER_TERRITORIES_PROPERTIES = {
  routeName: "Territorio",
  custmerCode: "Código de cliente",
  custmerName: "Nombre de cliente",
  companyName: "Compañia",
};

export const ROUTES_TERRITORIES_EXPORT_ID = "Reporte - Rutas de territorios";
export const ROUTES_TERRITORIES_TITLE = "Reporte - Rutas de territorios";

export const ROUTES_TERRITORIES_PROPERTIES = {
  routeName: "Territorio",
  subRouteName: "Ruta",
  responsibleName: "Responsable",
  type: "Tipo de ruta",
  function: "Función",
  areaName: "Area de ruta",
  plantName: "Planta",
  companyName: "Compañia"
};